<template>
    <div class="container">
        <b-modal 
            :model-value="modEditaRedFila" 
            :no-close-on-backdrop="true" 
            hide-footer
            centered
            size="lg"
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            @hide="closeModal"
        >
            <div class="uniform-modal-body" v-if="dataRedFila && dataRedFila[0]">
                <!-- Información principal -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.niif }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input v-model="dataRedFila[0].niif" type="number" class="form-input" :placeholder="labels.placeholderNiif" />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.descripcion }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input v-model="dataRedFila[0].descripcion" type="text" class="form-input" :placeholder="labels.placeholderDescripcion" />
                    </b-col>
                </b-row>

                <!-- Niveles -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.primerNivel }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input v-model="dataRedFila[0].primer_nivel" type="number" class="form-input" :placeholder="labels.placeholderPrimerNivel" />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.segundoNivel }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input v-model="dataRedFila[0].segundo_nivel" type="number" class="form-input" :placeholder="labels.placeholderSegundoNivel" />
                    </b-col>
                </b-row>

                <!-- Configuración -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.actual }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select v-model="dataRedFila[0].actual" class="form-input">
                            <option value="">{{ labels.select }}</option>
                            <option value="1">{{ labels.yes }}</option>
                            <option value="0">{{ labels.not }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.operacion }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select v-model="dataRedFila[0].operacion" class="form-input">
                            <option value="">{{ labels.select }}</option>
                            <option value="+">{{ labels.sumar }}</option>
                            <option value="-">{{ labels.restar }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Pestañas de selección -->
                <b-row class="d-flex align-items-start uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.niifSelect }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <div class="tabs-container">
                            <!-- Pestañas -->
                            <div class="tabs-header">
                                <button 
                                    class="tab-button" 
                                    :class="{ active: activeTab === 'niif' }"
                                    @click="changeTab('niif')"
                                >
                                    {{ labels.tabNiif }}
                                </button>
                                <button 
                                    class="tab-button" 
                                    :class="{ active: activeTab === 'redefiniciones' }"
                                    @click="changeTab('redefiniciones')"
                                >
                                    {{ labels.tabRedefiniciones }}
                                </button>
                            </div>

                            <!-- Contenido de pestañas -->
                            <div class="tab-content">
                                <!-- Pestaña NIIF -->
                                <div v-if="activeTab === 'niif'" class="niif-selection-container">
                                    <!-- Filtros -->
                                    <div class="criterio-inputs-wrapper mb-2">
                                        <b-form-input 
                                            v-model="searchTerm" 
                                            type="text" 
                                            class="form-input"
                                            style="height: 34px; font-size: 13px; margin-bottom: 6px;"
                                            :placeholder="labels.searchPlaceholder"
                                            @input="filterNiifs"
                                        />
                                    </div>

                                    <div class="accounts-section">
                                        <div v-if="sortedNiifs.length > 0" class="accounts-list">
                                            <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                                                <b-button 
                                                    size="sm"
                                                    style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                                    @click="toggleSelectAll"
                                                >
                                                    {{ selectAll ? labels.deselectAll : labels.selectAll }}
                                                </b-button>
                                                <span style="font-size: 13px; color: #6c757d;">
                                                    {{ labels.selected }}: <strong>{{ selectedNiifs?.length || 0 }}</strong> / {{ sortedNiifs?.length || 0 }}
                                                </span>
                                            </div>

                                            <div class="custom-scroll-table">
                                                <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                                    <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                                        <tr>
                                                            <th style="width: 80px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px; cursor: pointer;" @click="sortBy('niif')">
                                                                {{ labels.niif }}
                                                                <span class="sort-indicator" v-if="sortColumn === 'niif'">
                                                                    {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                                                </span>
                                                            </th>
                                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px; cursor: pointer;" @click="sortBy('descripcion')">
                                                                {{ labels.description }}
                                                                <span class="sort-indicator" v-if="sortColumn === 'descripcion'">
                                                                    {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                                                </span>
                                                            </th>
                                                            <th style="width: 70px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px; cursor: pointer;" @click="sortBy('primer_nivel')">
                                                                {{ labels.levelFirst }}
                                                                <span class="sort-indicator" v-if="sortColumn === 'primer_nivel'">
                                                                    {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                                                </span>
                                                            </th>
                                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px; cursor: pointer;" @click="sortBy('firstLevelDesc')">
                                                                {{ labels.levelFirstDesc }}
                                                                <span class="sort-indicator" v-if="sortColumn === 'firstLevelDesc'">
                                                                    {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                                                </span>
                                                            </th>
                                                            <th style="width: 70px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px; cursor: pointer;" @click="sortBy('segundo_nivel')">
                                                                {{ labels.levelSecond }}
                                                                <span class="sort-indicator" v-if="sortColumn === 'segundo_nivel'">
                                                                    {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                                                </span>
                                                            </th>
                                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px; cursor: pointer;" @click="sortBy('secondLevelDesc')">
                                                                {{ labels.levelSecondDesc }}
                                                                <span class="sort-indicator" v-if="sortColumn === 'secondLevelDesc'">
                                                                    {{ sortDirection === 'asc' ? '↑' : '↓' }}
                                                                </span>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr 
                                                            v-for="niif in sortedNiifs" 
                                                            :key="niif.id"
                                                            @click="toggleNiifSelection(niif)"
                                                            :class="{'table-active-blue': isNiifSelected(niif)}"
                                                            style="cursor: pointer;"
                                                        >
                                                            <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                                                <strong>{{ niif?.niif || '' }}</strong>
                                                            </td>
                                                            <td style="padding: 5px 8px;" :title="niif.nameNiif || niif.descripcion">
                                                                {{ niif?.nameNiif || niif?.descripcion || '-' }}
                                                            </td>
                                                            <td style="padding: 5px 8px;">
                                                                {{ niif?.primer_nivel || '-' }}
                                                            </td>
                                                            <td style="padding: 5px 8px;" :title="getFirstLevelDescription(niif.primer_nivel)">
                                                                {{ getFirstLevelDescription(niif?.primer_nivel) }}
                                                            </td>
                                                            <td style="padding: 5px 8px;">
                                                                {{ niif?.segundo_nivel || '-' }}
                                                            </td>
                                                            <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="getSecondLevelDescription(niif.niif)">
                                                                {{ getSecondLevelDescription(niif?.niif) }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div v-if="sortedNiifs?.length === 0" class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                                                <span class="text-muted" style="font-size: 13px;">{{ labels.noResults }}</span>
                                            </div>
                                        </div>

                                        <div v-else class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                                            <span class="text-muted" style="font-size: 13px;">{{ labels.noResults }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Pestaña Redefiniciones -->
                                <div v-if="activeTab === 'redefiniciones'" class="redefiniciones-selection-container">
                                    <div class="criterio-inputs-wrapper mb-2">
                                        <b-form-input 
                                            v-model="searchRedefinicion" 
                                            type="text" 
                                            class="form-input"
                                            style="height: 34px; font-size: 13px;"
                                            :placeholder="labels.searchRedefPlaceholder"
                                            @input="filterRedefiniciones"
                                        />
                                    </div>

                                    <div class="accounts-section">
                                        <div v-if="sortedRedefiniciones.length > 0" class="accounts-list">
                                            <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                                                <b-button 
                                                    size="sm"
                                                    style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                                    @click="toggleSelectAllRedef"
                                                >
                                                    {{ selectAllRedef ? labels.deselectAll : labels.selectAll }}
                                                </b-button>
                                                <span style="font-size: 13px; color: #6c757d;">
                                                    {{ labels.selected }}: <strong>{{ selectedRedefiniciones?.length || 0 }}</strong> / {{ sortedRedefiniciones?.length || 0 }}
                                                </span>
                                            </div>

                                            <div class="custom-scroll-table">
                                                <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                                    <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                                        <tr>
                                                            <th style="width: 80px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px; cursor: pointer;" @click="sortByRedef('niif')">
                                                                {{ labels.niif }}
                                                                <span class="sort-indicator" v-if="sortColumnRedef === 'niif'">
                                                                    {{ sortDirectionRedef === 'asc' ? '↑' : '↓' }}
                                                                </span>
                                                            </th>
                                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px; cursor: pointer;" @click="sortByRedef('descripcion')">
                                                                {{ labels.description }}
                                                                <span class="sort-indicator" v-if="sortColumnRedef === 'descripcion'">
                                                                    {{ sortDirectionRedef === 'asc' ? '↑' : '↓' }}
                                                                </span>
                                                            </th>
                                                            <th style="width: 70px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                {{ labels.levelFirst }}
                                                            </th>
                                                            <th style="width: 70px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                {{ labels.levelSecond }}
                                                            </th>
                                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                                {{ labels.formulacion }}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr 
                                                            v-for="redef in sortedRedefiniciones" 
                                                            :key="redef.id"
                                                            @click="toggleRedefinicionSelection(redef)"
                                                            :class="{'table-active-blue': isRedefinicionSelected(redef)}"
                                                            style="cursor: pointer;"
                                                        >
                                                            <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                                                <strong>{{ redef?.niif || '' }}</strong>
                                                            </td>
                                                            <td style="padding: 5px 8px;" :title="redef.descripcion">
                                                                {{ redef?.descripcion || '-' }}
                                                            </td>
                                                            <td style="padding: 5px 8px;">
                                                                {{ redef?.primer_nivel || '-' }}
                                                            </td>
                                                            <td style="padding: 5px 8px;">
                                                                {{ redef?.segundo_nivel || '-' }}
                                                            </td>
                                                            <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="redef.formulacion">
                                                                {{ truncateFormulation(redef?.formulacion) }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div v-if="sortedRedefiniciones?.length === 0" class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                                                <span class="text-muted" style="font-size: 13px;">{{ labels.noRedefResults }}</span>
                                            </div>
                                        </div>

                                        <div v-else class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                                            <span class="text-muted" style="font-size: 13px;">{{ labels.noRedefResults }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="closeDialog">
                        {{ labels.close }}
                    </b-button>
                    <b-button class="reset-btn-primary ml-2" @click="confirmSave" :disabled="isSaving">
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
            <div v-else class="uniform-modal-body text-center py-5">
                <b-spinner></b-spinner>
                <p class="mt-2">{{ labels.loading }}</p>
            </div>
        </b-modal>
    </div>
</template>

<script>
import PrimerNivel from '../../../services/PrimerNivel'; 
import SegundoNivel from '../../../services/SegundoNivel'; 
import PlanConsolidacion from '../../../services/PlanConsolidacion'; 
import RedefinicionFila from '../../../services/RedefinicionFila'; 

export default {
    name: 'EditaRedefinicionFila',
    props: ['modEditaRedFila', 'dataRedFila', 'vigenciaSelected', 'codReporte'],
    data: () => ({
        listFirstLevel: [],
        listSecondLev: [],
        listNiif: [],
        filteredNiifs: [],
        selectedNiifs: [],
        searchTerm: '',
        selectAll: false,
        originalData: null,
        hasUnsavedChanges: false,
        isSaving: false,
        initialLoadComplete: false,
        sortColumn: 'niif',
        sortDirection: 'asc',
        activeTab: 'niif',
        listRedefiniciones: [],
        filteredRedefiniciones: [],
        searchRedefinicion: '',
        sortColumnRedef: 'niif',
        sortDirectionRedef: 'asc',
        selectedRedefiniciones: [],
        selectAllRedef: false,
        isLoading: false
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar redefinición fila",
                    save: "Guardar",
                    close: "Cerrar",
                    niif: "Niif",
                    descripcion: "Descripción",
                    primerNivel: "Primer nivel",
                    segundoNivel: "Segundo nivel",
                    actual: "Actual",
                    operacion: "Operación",
                    niifSelect: "Seleccionar NIIF",
                    select: "Seleccione...",
                    yes: "SI",
                    not: "NO",
                    sumar: "Sumar",
                    restar: "Restar",
                    searchPlaceholder: "Buscar NIIF...",
                    selected: "Seleccionados",
                    levelFirst: "Nivel 1",
                    levelSecond: "Nivel 2",
                    levelFirstDesc: "Desc. Nivel 1",
                    levelSecondDesc: "Desc. Nivel 2",
                    description: "Descripción",
                    noResults: "No se encontraron resultados",
                    tabNiif: "NIIFs",
                    tabRedefiniciones: "Redefiniciones",
                    searchRedefPlaceholder: "Buscar redefiniciones...",
                    noRedefResults: "No se encontraron redefiniciones",
                    showing: "Mostrando",
                    formulacion: "Formulación",
                    selectAll: "Seleccionar todas",
                    deselectAll: "Deseleccionar todas",
                    placeholderNiif: "Ingrese NIIF",
                    placeholderDescripcion: "Ingrese descripción",
                    placeholderPrimerNivel: "Ingrese primer nivel",
                    placeholderSegundoNivel: "Ingrese segundo nivel",
                    loading: "Cargando..."
                }
            } else {
                return {
                    title: "Edit row redefinition",
                    save: "Save",
                    close: "Close",
                    niif: "Niif",
                    descripcion: "Description",
                    primerNivel: "First level",
                    segundoNivel: "Second level",
                    actual: "Current",
                    operacion: "Operation",
                    niifSelect: "Select NIIF",
                    select: "Select...",
                    yes: "YES",
                    not: "NO",
                    sumar: "Add",
                    restar: "Subtract",
                    searchPlaceholder: "Search NIIF...",
                    selected: "Selected",
                    levelFirst: "Level 1",
                    levelSecond: "Level 2",
                    levelFirstDesc: "Level 1 Desc",
                    levelSecondDesc: "Level 2 Desc",
                    description: "Description",
                    noResults: "No results found",
                    tabNiif: "NIIFs",
                    tabRedefiniciones: "Redefinitions",
                    searchRedefPlaceholder: "Search redefinitions...",
                    noRedefResults: "No redefinitions found",
                    showing: "Showing",
                    formulacion: "Formulation",
                    selectAll: "Select all",
                    deselectAll: "Deselect all",
                    placeholderNiif: "Enter NIIF",
                    placeholderDescripcion: "Enter description",
                    placeholderPrimerNivel: "Enter first level",
                    placeholderSegundoNivel: "Enter second level",
                    loading: "Loading..."
                }
            }
        },
        sortedNiifs() {
            if (!this.filteredNiifs.length) return [];
            return [...this.filteredNiifs].sort((a, b) => {
                let aValue, bValue;
                switch (this.sortColumn) {
                    case 'niif':
                        aValue = parseInt(a.niif); 
                        bValue = parseInt(b.niif); 
                        break;
                    case 'descripcion':
                        aValue = (a.nameNiif || a.descripcion || '').toLowerCase(); 
                        bValue = (b.nameNiif || b.descripcion || '').toLowerCase(); 
                        break;
                    case 'primer_nivel':
                        aValue = parseInt(a.primer_nivel); 
                        bValue = parseInt(b.primer_nivel); 
                        break;
                    case 'segundo_nivel':
                        aValue = parseInt(a.segundo_nivel); 
                        bValue = parseInt(b.segundo_nivel); 
                        break;
                    case 'firstLevelDesc':
                        aValue = this.getFirstLevelDescription(a.primer_nivel).toLowerCase();
                        bValue = this.getFirstLevelDescription(b.primer_nivel).toLowerCase();
                        break;
                    case 'secondLevelDesc':
                        aValue = this.getSecondLevelDescription(a.niif).toLowerCase();
                        bValue = this.getSecondLevelDescription(b.niif).toLowerCase();
                        break;
                    default:
                        aValue = a[this.sortColumn];
                        bValue = b[this.sortColumn];
                }
                if (aValue == null) aValue = '';
                if (bValue == null) bValue = '';
                let result = 0;
                if (typeof aValue === 'string') {
                    result = aValue.localeCompare(bValue); 
                } else {
                    result = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
                }
                return this.sortDirection === 'desc' ? -result : result;
            });
        },
        sortedRedefiniciones() {
            if (!this.filteredRedefiniciones.length) return [];
            return [...this.filteredRedefiniciones].sort((a, b) => {
                let aValue, bValue;
                switch (this.sortColumnRedef) {
                    case 'niif':
                        aValue = parseInt(a.niif); 
                        bValue = parseInt(b.niif); 
                        break;
                    case 'descripcion':
                        aValue = (a.descripcion || '').toLowerCase(); 
                        bValue = (b.descripcion || '').toLowerCase(); 
                        break;
                    default:
                        aValue = a[this.sortColumnRedef];
                        bValue = b[this.sortColumnRedef];
                }
                let result = 0;
                if (typeof aValue === 'string') {
                    result = aValue.localeCompare(bValue); 
                } else {
                    result = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
                }
                return this.sortDirectionRedef === 'desc' ? -result : result;
            });
        }
    },
    watch: {
        dataRedFila: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (newVal && newVal[0]) {
                    this.originalData = { ...newVal[0] };
                    if (this.initialLoadComplete) {
                        this.loadSelectedNiifs();
                    }
                } else {
                    this.selectedNiifs = [];
                    if (this.listNiif) {
                        this.listNiif.forEach(n => n._selected = false);
                    }
                }
            }
        },
        'dataRedFila[0].niif'() { this.hasUnsavedChanges = true; },
        'dataRedFila[0].descripcion'() { this.hasUnsavedChanges = true; },
        'dataRedFila[0].primer_nivel'() { this.hasUnsavedChanges = true; },
        'dataRedFila[0].segundo_nivel'() { this.hasUnsavedChanges = true; },
        'dataRedFila[0].actual'() { this.hasUnsavedChanges = true; },
        'dataRedFila[0].operacion'() { this.hasUnsavedChanges = true; },
        selectedNiifs: {
            handler() {
                this.hasUnsavedChanges = true;
                this.updateSelectAllState();
            },
            deep: true
        },
        modEditaRedFila(valNew) {
            if (valNew) {
                this.isLoading = true;
                this.$nextTick(() => {
                    this.loadNiifData();
                });
            } else {
                this.searchTerm = '';
                this.selectAll = false;
                this.initialLoadComplete = false;
                this.sortColumn = 'niif';
                this.sortDirection = 'asc';
                this.isLoading = false;
            }
        }
    },
    methods: {
        // ==== Métodos para NIIF ====
        isNiifSelected(niif) {
            if (!niif || niif.niif === undefined || niif.niif === null) return false;
            return this.selectedNiifs.some(item => String(item.niif) === String(niif.niif));
        },

        toggleNiifSelection(niif) {
            if (!niif || niif.niif === undefined || niif.niif === null) return;
            const index = this.selectedNiifs.findIndex(item => String(item.niif) === String(niif.niif));
            if (index > -1) {
                this.selectedNiifs.splice(index, 1);
                niif._selected = false;
            } else {
                this.selectedNiifs.push(niif);
                niif._selected = true;
            }
            this.updateSelectAllState();
        },

        sortBy(column) {
            if (this.sortColumn === column) {
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortColumn = column;
                this.sortDirection = 'asc';
            }
        },

        loadNiifData() {
            if (!this.codReporte || !this.vigenciaSelected) {
                this.isLoading = false;
                return;
            }
            
            PlanConsolidacion.getPlanConsPorCompVige(this.vigenciaSelected, this.codReporte)
                .then((res) => { 
                    this.listNiif = res.data.planConsNiif || [];
                    this.listNiif.forEach(n => n._selected = false);
                    this.filteredNiifs = [...this.listNiif];
                    setTimeout(() => {
                        this.loadSelectedNiifs();
                    }, 100);
                    return this.loadLevelDescriptions();
                })
                .then(() => { 
                    this.initialLoadComplete = true;
                    this.isLoading = false;
                })
                .catch((err) => { 
                    console.log('Error cargando NIIF:', err); 
                    this.filteredNiifs = [];
                    this.initialLoadComplete = true;
                    this.isLoading = false;
                });
        },

        loadSelectedNiifs() {
            if (!this.dataRedFila || !this.dataRedFila[0]) {
                this.selectedNiifs = [];
                if (this.listNiif) {
                    this.listNiif.forEach(n => n._selected = false);
                }
                return;
            }
            let selectedCodes = [];
            if (this.dataRedFila[0].listaNiif && this.dataRedFila[0].listaNiif.length > 0) {
                selectedCodes = this.dataRedFila[0].listaNiif.map(n => parseInt(n));
            } else if (this.dataRedFila[0].formulacion) {
                selectedCodes = this.extractNiifCodesFromFormulation(this.dataRedFila[0].formulacion);
            }
            if (this.listNiif && this.listNiif.length) {
                this.listNiif.forEach(niif => {
                    niif._selected = selectedCodes.includes(parseInt(niif.niif));
                });
                this.selectedNiifs = this.listNiif.filter(niif => niif._selected);
            } else {
                this.selectedNiifs = [];
            }
            this.updateSelectAllState();
        },

        extractNiifCodesFromFormulation(formulation) {
            if (!formulation) return [];
            const niifMatch = formulation.match(/Niif\(([^)]+)\)/i); 
            if (niifMatch) {
                return niifMatch[1].split(',')?.map(num => parseInt(num.trim()))?.filter(num => !isNaN(num));
            }
            return formulation?.replace(/[+-]/g, ',').split(',')?.map(n => parseInt(n.trim()))?.filter(n => !isNaN(n));
        },

        loadLevelDescriptions() {
            return new Promise((resolve) => {
                PrimerNivel.getFirstLevelByReporte(this.codReporte)
                    .then((result) => { 
                        this.listFirstLevel = result.data.firstLevByReport || [];
                        const uniqueFirstLevels = [...new Set(this.listNiif
                            .filter(niif => niif.primer_nivel) 
                            .map(niif => niif.primer_nivel)
                        )];
                        if (uniqueFirstLevels.length > 0) { 
                            this.loadAllSecondLevelDescriptions(uniqueFirstLevels).then(resolve);
                        } else {
                            resolve();
                        }
                    })
                    .catch((err) => { 
                        console.log(err); 
                        resolve();
                    });
            });
        },

        loadAllSecondLevelDescriptions(firstLevels) {
            return new Promise((resolve) => {
                this.listSecondLev = [];
                const promises = firstLevels.map(firstLevel => 
                    SegundoNivel.getAllLevelSecondByLevelFirstByReport(firstLevel, this.codReporte)
                        .then(res => { 
                            if (res.data.secondLevByFirstLev) { 
                                this.listSecondLev = [...this.listSecondLev, ...res.data.secondLevByFirstLev];
                            }
                        })
                        .catch(err => { 
                            console.log(`Error loading second levels for first level ${firstLevel}:`, err); 
                        })
                );
                Promise.all(promises).then(resolve);
            });
        },

        filterNiifs() {
            if (!this.searchTerm) {
                this.filteredNiifs = [...this.listNiif];
            } else {
                const term = this.searchTerm.toLowerCase();
                this.filteredNiifs = this.listNiif.filter(niif => 
                    niif.niif.toString().includes(term) || 
                    (niif.nameNiif && niif.nameNiif.toLowerCase().includes(term)) || 
                    (niif.descripcion && niif.descripcion.toLowerCase().includes(term)) || 
                    (niif.primer_nivel && niif.primer_nivel.toString().includes(term)) || 
                    (niif.segundo_nivel && niif.segundo_nivel.toString().includes(term))
                );
            }
            this.updateSelectAllState();
        },

        updateSelectAllState() {
            if (!this.filteredNiifs || this.filteredNiifs.length === 0) {
                this.selectAll = false;
                return;
            }
            this.selectAll = this.filteredNiifs.every(niif => niif._selected);
        },

        toggleSelectAll() {
            this.selectAll = !this.selectAll;
            const selectedNiifCodes = this.selectedNiifs.map(item => String(item.niif));
            
            if (this.selectAll) {
                this.filteredNiifs.forEach(niif => {
                    const niifStr = String(niif.niif);
                    if (!selectedNiifCodes.includes(niifStr)) {
                        this.selectedNiifs.push(niif);
                        niif._selected = true;
                    }
                });
            } else {
                const filteredCodes = this.filteredNiifs.map(n => String(n.niif));
                this.selectedNiifs = this.selectedNiifs.filter(s => !filteredCodes.includes(String(s.niif)));
                this.filteredNiifs.forEach(niif => niif._selected = false);
            }
        },

        getFirstLevelDescription(levelCode) {
            if (!levelCode) return '-';
            const level = this.listFirstLevel.find(item => item.primer_nivel == levelCode);
            return level ? level?.descripcion : '-';
        },

        getSecondLevelDescription(niif) {
            if (!niif) return '-';
            const level = this.listNiif.find(r_niif => r_niif.niif == niif);
            return level ? level?.nameSegundoNivel : '-';
        },

        getFormulationPreview() {
            if (this.selectedNiifs.length === 0) return '-';
            const niifCodes = this.selectedNiifs.map(niif => niif.niif);
            const operation = this.dataRedFila[0].operacion || '+';
            if (niifCodes?.length === 1) return niifCodes[0];
            return niifCodes?.join(` ${operation} `);
        },

        restoreOriginalValues() {
            if (this.originalData && this.dataRedFila[0]) {
                Object.assign(this.dataRedFila[0], this.originalData);
                this.loadSelectedNiifs();
            }
        },

        // ==== Métodos para Redefiniciones ====
        isRedefinicionSelected(redef) {
            if (!redef || redef.id === undefined || redef.id === null) return false;
            return this.selectedRedefiniciones.some(item => item.id === redef.id);
        },

        toggleRedefinicionSelection(redef) {
            if (!redef || redef.id === undefined || redef.id === null) return;
            const index = this.selectedRedefiniciones.findIndex(item => item.id === redef.id);
            if (index > -1) {
                this.selectedRedefiniciones.splice(index, 1);
                redef._selected = false;
            } else {
                this.selectedRedefiniciones.push(redef);
                redef._selected = true;
            }
            this.updateSelectAllRedefState();
            this.applyRedefinicionesSelection();
        },

        toggleSelectAllRedef() {
            this.selectAllRedef = !this.selectAllRedef;
            const selectedRedefIds = this.selectedRedefiniciones.map(item => item.id);
            
            if (this.selectAllRedef) {
                this.filteredRedefiniciones.forEach(redef => {
                    if (!selectedRedefIds.includes(redef.id)) {
                        this.selectedRedefiniciones.push(redef);
                        redef._selected = true;
                    }
                });
            } else {
                const filteredIds = this.filteredRedefiniciones.map(r => r.id);
                this.selectedRedefiniciones = this.selectedRedefiniciones.filter(s => !filteredIds.includes(s.id));
                this.filteredRedefiniciones.forEach(redef => redef._selected = false);
            }
            this.applyRedefinicionesSelection();
        },

        updateSelectAllRedefState() {
            if (!this.filteredRedefiniciones || this.filteredRedefiniciones.length === 0) {
                this.selectAllRedef = false;
                return;
            }
            this.selectAllRedef = this.filteredRedefiniciones.every(redef => redef._selected);
        },

        applyRedefinicionesSelection() {
            if (this.selectedRedefiniciones.length === 0) return;
            const allNiifCodes = new Set();
            this.selectedRedefiniciones.forEach(redef => {
                const niifCodes = this.extractNiifCodesFromFormulation(redef.formulacion);
                niifCodes.forEach(code => allNiifCodes.add(code));
            });
            const uniqueNiifCodes = Array.from(allNiifCodes);
            if (this.listNiif && this.listNiif.length) {
                this.listNiif.forEach(niif => {
                    niif._selected = uniqueNiifCodes.includes(parseInt(niif.niif));
                });
                this.selectedNiifs = this.listNiif.filter(niif => niif._selected);
            }
            this.updateSelectAllState();
            this.hasUnsavedChanges = true;
        },

        clearRedefinicionesSelection() {
            this.selectedRedefiniciones = [];
            if (this.listRedefiniciones) {
                this.listRedefiniciones.forEach(redef => redef._selected = false);
            }
            this.selectAllRedef = false;
        },

        loadRedefiniciones() {
            if (!this.codReporte) return;
            
            RedefinicionFila.getAllRedefinicionFilas(this.codReporte)
                .then(res => { 
                    this.listRedefiniciones = res.data.redefinicionFila || [];
                    if (this.dataRedFila && this.dataRedFila[0]) {
                        this.listRedefiniciones = this.listRedefiniciones.filter(item =>
                            item.id !== this.dataRedFila[0].id
                        );
                    }
                    this.listRedefiniciones.forEach(redef => redef._selected = false);
                    this.filteredRedefiniciones = [...this.listRedefiniciones];
                    this.selectedRedefiniciones = [];
                })
                .catch(err => { 
                    console.log('Error cargando redefiniciones:', err); 
                    this.listRedefiniciones = [];
                    this.filteredRedefiniciones = [];
                    this.selectedRedefiniciones = [];
                });
        },

        filterRedefiniciones() {
            if (!this.searchRedefinicion) {
                this.filteredRedefiniciones = [...this.listRedefiniciones];
            } else {
                const term = this.searchRedefinicion.toLowerCase();
                this.filteredRedefiniciones = this.listRedefiniciones.filter(item =>
                    item.niif.toString().includes(term) || 
                    (item.descripcion && item.descripcion.toLowerCase().includes(term))
                );
            }
            this.updateSelectAllRedefState();
        },

        sortByRedef(column) {
            if (this.sortColumnRedef === column) {
                this.sortDirectionRedef = this.sortDirectionRedef === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortColumnRedef = column;
                this.sortDirectionRedef = 'asc';
            }
        },

        truncateFormulation(formulation) {
            if (!formulation) return '';
            if (formulation.length > 50) { 
                const niifMatch = formulation.match(/^(Niif\([^)]+\))/i); 
                if (niifMatch) {
                    const niifPart = niifMatch[1];
                    if (niifPart.length > 50) { 
                        const numbersMatch = niifPart.match(/Niif\(([^)]+)\)/i); 
                        if (numbersMatch) {
                            const numbers = numbersMatch[1].split(','); 
                            if (numbers.length > 8) { 
                                const truncatedNumbers = [
                                    ...numbers.slice(0, 5), 
                                    '...', 
                                    ...numbers.slice(-3) 
                                ].join(','); 
                                return `Niif(${truncatedNumbers})`;
                            }
                        }
                    }
                    return niifPart;
                }
                return formulation?.substring(0, 50) + '..? ';
            }
            return formulation;
        },

        changeTab(tab) {
            this.activeTab = tab;
            if (tab === 'redefiniciones' && (!this.listRedefiniciones || this.listRedefiniciones.length === 0)) {
                this.loadRedefiniciones();
            }
            if (tab === 'redefiniciones' && this.selectedNiifs.length === 0) {
                this.clearRedefinicionesSelection();
            }
        },

        // ==== Acciones del modal ====
        closeDialog() {
            if (this.hasUnsavedChanges && !this.isSaving) {
                const message = this.$store.state._language == "es-ES"
                    ? "Tienes cambios sin guardar. ¿Quieres cerrar sin guardar?"
                    : "You have unsaved changes. Do you want to close without saving?";
                if (window.confirm(message)) { 
                    this.restoreOriginalValues();
                    this.closeModal();
                }
            } else {
                this.closeModal();
            }
        },

        confirmSave() {
            if (!this.dataRedFila || !this.dataRedFila[0]) {
                this.$toast.error('No hay datos para guardar');
                return;
            }
            const message = this.$store.state._language == "es-ES"
                ? "¿Está seguro que desea guardar los cambios?"
                : "Are you sure you want to save the changes?";
            if (window.confirm(message)) { 
                this.guardaRedFila();
            }
        },

        guardaRedFila() {
            this.isSaving = true;
            const selectedNiifCodes = this.selectedNiifs.map(niif => niif.niif);
            let infoFila = {
                'id': this.dataRedFila[0].id,
                'codReporte': this.codReporte,
                'primer_nivel': this.dataRedFila[0].primer_nivel,
                'segundo_nivel': this.dataRedFila[0].segundo_nivel,
                'niif': this.dataRedFila[0].niif,
                'descripcion': this.dataRedFila[0].descripcion,
                'contable': 0,
                'cuenta': null,
                'actual': this.dataRedFila[0].actual,
                'operacion': this.dataRedFila[0].operacion,
                'formulacion': this.getFormulationPreview(),
                'listaNiif': selectedNiifCodes,
                'idUser': this.$store.state.userId
            };
            RedefinicionFila.updateRedefinicionFila(infoFila) 
                .then((res) => { 
                    this.$toast.success(res.data.message);
                    this.hasUnsavedChanges = false;
                    this.closeModal();
                    this.$emit('reload');
                })
                .catch((error) => { 
                    console.log(error); 
                    this.$toast.error("Error al guardar los cambios");
                })
                .finally(() => { 
                    this.isSaving = false;
                });
        },

        closeModal() {
            this.$emit('cierraModal', false);
        }
    },
    mounted() {
        if (this.codReporte) {
            PrimerNivel.getFirstLevelByReporte(this.codReporte)
                .then((result) => { 
                    this.listFirstLevel = result.data.firstLevByReport || [];
                })
                .catch((err) => { 
                    console.log(err); 
                });
        }
        if (this.modEditaRedFila && this.dataRedFila && this.dataRedFila[0]) {
            this.$nextTick(() => {
                this.loadNiifData();
            });
        }
    }
}
</script>

<style src="../../main.css"></style>

<style scoped>
/* ========== ESTILOS PARA SELECTOR MÚLTIPLE ========== */
.criterio-inputs-wrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
}

.accounts-section {
    margin-top: 8px;
}

.select-all-container {
    padding: 4px 0;
}

.custom-scroll-table {
    height: 200px !important;
    min-height: 200px !important;
    max-height: 200px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    display: block !important;
    position: relative !important;
}

.custom-scroll-table table {
    display: table !important;
    width: 100% !important;
    table-layout: fixed !important;
    margin-bottom: 0 !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
}

.custom-scroll-table table thead {
    display: table-header-group !important;
    width: 100% !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
}

.custom-scroll-table table thead tr {
    display: table-row !important;
    width: 100% !important;
}

.custom-scroll-table table thead th {
    background-color: #f8f9fa !important;
    border-bottom: 2px solid #dee2e6 !important;
    padding: 6px 8px !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    color: #495057 !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
}

.custom-scroll-table table tbody {
    display: table-row-group !important;
    width: 100% !important;
}

.custom-scroll-table table tbody tr {
    display: table-row !important;
    width: 100% !important;
    cursor: pointer !important;
    border-radius: 8px !important;
}

.custom-scroll-table table tbody td {
    padding: 5px 8px !important;
    border: none !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
}

.custom-scroll-table table tbody td:first-child {
    border-radius: 8px 0 0 8px !important;
}

.custom-scroll-table table tbody td:last-child {
    border-radius: 0 8px 8px 0 !important;
}

.custom-scroll-table table tbody tr:hover td {
    background-color: #f5f9ff !important;
}

.custom-scroll-table::-webkit-scrollbar {
    width: 8px !important;
}

.custom-scroll-table::-webkit-scrollbar-track {
    background: #f1f1f1 !important;
    border-radius: 4px !important;
}

.custom-scroll-table::-webkit-scrollbar-thumb {
    background: #c1c1c1 !important;
    border-radius: 4px !important;
}

.custom-scroll-table::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8 !important;
}

.table-active-blue {
    background-color: #e3f0ff !important;
    border-radius: 8px !important;
}

.table-active-blue td {
    background-color: #e3f0ff !important;
}

.table-active-blue td:first-child {
    border-radius: 8px 0 0 8px !important;
}

.table-active-blue td:last-child {
    border-radius: 0 8px 8px 0 !important;
}

/* Estilos de pestañas */
.tabs-container {
    width: 100%;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    overflow: hidden;
    background: white;
}

.tabs-header {
    display: flex;
    border-bottom: 1px solid #dee2e6;
    background: #f8f9fa;
}

.tab-button {
    padding: 8px 16px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: #495057;
    cursor: pointer;
    transition: all 0.2s;
    flex: 1;
}

.tab-button:hover {
    background: #e9ecef;
}

.tab-button.active {
    background: white;
    color: #2e507a;
    border-bottom: 2px solid #2e507a;
}

.tab-content {
    padding: 12px;
}

/* Estilos generales del modal */
.uniform-modal-body {
    padding: 8px 4px 4px 4px;
}

.uniform-form-row {
    margin-bottom: 12px;
}

.uniform-label-col label {
    margin-bottom: 0;
    font-weight: 500;
    font-size: 14px;
}

.form-input {
    width: 100%;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

.uniform-actions-wrap {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e9ecef;
}

.reset-btn-primary {
    background-color: #2e507a !important;
    border: 1px solid #2e507a !important;
    color: white !important;
    padding: 8px 24px;
    border-radius: 6px;
    font-weight: 500;
}

.reset-btn-primary:hover:not(:disabled) {
    background-color: #1f3f62 !important;
    border-color: #1f3f62 !important;
}

.reset-btn-primary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.reset-btn-secondary {
    background-color: #f8f9fa !important;
    border: 1px solid #ced4da !important;
    color: #495057 !important;
    padding: 8px 24px;
    border-radius: 6px;
    font-weight: 500;
}

.reset-btn-secondary:hover:not(:disabled) {
    background-color: #e9ecef !important;
    border-color: #adb5bd !important;
}

.reset-modal-header {
    background-color: #2e507a;
    color: white;
    padding: 16px 20px;
    border-radius: 8px 8px 0 0;
}

.reset-modal-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}

.reset-modal-body {
    padding: 24px 20px;
    background-color: #f8f9fa;
}

/* Sort indicator */
.sort-indicator {
    display: inline-block;
    margin-left: 4px;
    font-size: 11px;
    color: #6c757d;
}

/* ========== RESPONSIVE ========== */
@media (max-width: 768px) {
    .custom-scroll-table {
        height: 160px !important;
        min-height: 160px !important;
        max-height: 160px !important;
    }

    .custom-scroll-table table tbody td {
        font-size: 12px !important;
        padding: 4px 6px !important;
    }

    .custom-scroll-table table thead th {
        font-size: 11px !important;
        padding: 4px 6px !important;
    }
}

@media (max-width: 576px) {
    .reset-dialog-actions {
        flex-direction: column;
    }
    
    .reset-dialog-actions .reset-btn-secondary,
    .reset-dialog-actions .reset-btn-primary {
        width: 100%;
        margin: 4px 0 !important;
    }

    .uniform-label-col {
        flex: 0 0 100%;
        max-width: 100%;
        margin-bottom: 4px;
        text-align: left !important;
    }
    
    .uniform-form-row .col-md-8 {
        flex: 0 0 100%;
        max-width: 100%;
    }

    .custom-scroll-table {
        height: 140px !important;
        min-height: 140px !important;
        max-height: 140px !important;
    }

    .custom-scroll-table table tbody td {
        font-size: 11px !important;
        padding: 3px 4px !important;
    }

    .custom-scroll-table table thead th {
        font-size: 10px !important;
        padding: 3px 4px !important;
    }
}
</style>